import script from "./myUpload.vue?vue&type=script&lang=ts&setup=true"
export * from "./myUpload.vue?vue&type=script&lang=ts&setup=true"

import "./myUpload.vue?vue&type=style&index=0&id=4db13866&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db13866"]])

export default __exports__